import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Products from "../ProductSection/Products";

const ProductsPage = () => {
  const location = useLocation();

  useEffect(() => {
    const sectionId = location.pathname.substring(1); // Remove leading "/"

    setTimeout(() => {
      const sectionElement = document.getElementById(sectionId);
      if (sectionElement) {
        sectionElement.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 100); // Small delay to ensure elements are rendered
  }, [location]);

  return (
    <div id="products" className="category-page">
     <Products/>
    </div>
  );
};

export default ProductsPage;